import { Phone, Mail, Globe, Facebook, Twitter, Linkedin, Instagram, MapPin } from 'react-feather';
import { Link } from 'react-router-dom';

const EMAIL_ADDRESS = 'hello@gambitgames.ug';
const PHONE_NUMBER = '+256 782 692271';

export function Footer() {
  return (
    <footer className="border-t border-gray-800 bg-gray-900 text-gray-300">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          {/* Brand */}
          <div>
            <Link to="/" className="text-xl font-bold text-white">
              Gambit <span className="text-[#12A2BF]">Games</span>
            </Link>
            <p className="mt-3 max-w-xs text-sm text-gray-400">
              Handcrafted wooden board games, custom builds, and user-requested designs. Made with
              love in Najjera, Kampala.
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="https://instagram.com/gambit_games_uganda"
                target="_blank"
                rel="noreferrer"
                className="rounded-md p-2 text-gray-400 hover:text-white hover:brightness-110"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://twitter.com/gambit_games_uganda"
                target="_blank"
                rel="noreferrer"
                className="rounded-md p-2 text-gray-400 hover:text-white hover:brightness-110"
                aria-label="Twitter"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://linkedin.com/gambit_games_uganda"
                target="_blank"
                rel="noreferrer"
                className="rounded-md p-2 text-gray-400 hover:text-white hover:brightness-110"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://gambitgames.pages.dev"
                className="rounded-md p-2 text-gray-400 hover:text-white hover:brightness-110"
                aria-label="Website"
              >
                <Globe size={18} />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400">Shop</h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/shop?category=classic" className="hover:text-white">
                  Classic Games (Chess, Checkers)
                </Link>
              </li>
              <li>
                <Link to="/shop?category=ancient" className="hover:text-white">
                  Ancient & Cultural (Omweso/Mancala)
                </Link>
              </li>
              <li>
                <Link to="/shop?category=travel" className="hover:text-white">
                  Travel Games
                </Link>
              </li>
              <li>
                <Link to="/shop?category=party" className="hover:text-white">
                  Party & Family (Ludo, Jenga)
                </Link>
              </li>
              <li>
                <Link to="/custom" className="hover:text-white">
                  Custom Orders
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400">
              Company
            </h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-white">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/craft" className="hover:text-white">
                  How It’s Made
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-white">
                  Playtime Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/policies" className="hover:text-white">
                  Policies
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400">
              Visit & Contact
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#12A2BF]" />
                <span>Najjera, Kampala, Uganda</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 text-[#12A2BF]" />
                <a href={`tel:${PHONE_NUMBER.replace(/\s/g, '')}`} className="hover:text-white">
                  {PHONE_NUMBER}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-[#12A2BF]" />
                <a href={`mailto:${EMAIL_ADDRESS}`} className="hover:text-white">
                  {EMAIL_ADDRESS}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Globe size={16} className="mt-0.5 text-[#12A2BF]" />
                <span>We currently deliver within Kampala.</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Badge */}
        <div className="mt-10">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#12A2BF] bg-[#12A2BF]/10 px-3 py-1 text-xs font-medium text-[#d3e5e8]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#12A2BF]" />
            Made in Uganda
          </span>
        </div>
      </div>

      <div className="border-t border-gray-800 py-4 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} Gambit Games Uganda. All rights reserved.
      </div>
    </footer>
  );
}
